import { createContext } from 'react';

/**
 * Разрешена ли пользователю правка результата экспертного заключения в карточке диалога.
 *
 * Правка результата — балла блока, значения справочника, комментария правила и статуса проверки —
 * открыта отдельным разрешением, а не самим доступом к диалогу: проверка результата остаётся
 * работой проверяющего, а не всякого читателя карточки. Признак нужен и в строках заключения, и в
 * списке правил под ними, поэтому раздаётся контекстом, а не по цепочке пропов.
 *
 * Значение по умолчанию — правка закрыта: не спросив разрешения, экран его и не обещает.
 */
export const ExpertReportResultEditContext = createContext(false);
